interface Befinit {
  locale: String;
  data: Array<{
    icon?: string;
    title: string;
    description: string;
  }>;
}

export default class BefinitLocale {
  public data: Array<{
    icon?: string;
    title: string;
    description: string;
  }> = [];
  constructor() {
    const { locale } = useI18n();
    this.data =
      dataLocales.find((item) => item.locale == locale.value)?.data ??
      dataLocales[0].data;
  }
}

const dataLocales: Array<Befinit> = [
  {
    locale: "en",
    data: [
      {
        icon: "collaborative.png",
        title: "No worries, no confusion",
        description:
          "Integrating QR Codes during initial planning and adding content only when ready to go live, even after printing, provides peace of mind and avoids confusion. You can edit your codes anytime and anywhere to ensure accurate messaging and seamless user experience.",
      },
      {
        icon: "portfolio.png",
        title: "High image quality and variety",
        description:
          "Our QR codes always maintain high resolution, regardless of where they are printed. You can download them in various formats, including JPG, PNG, SVG, or EPS, to ensure they look great on any medium.",
      },
      {
        icon: "illustration.png",
        title: "Designs available",
        description:
          "We offer a vast selection of stunning layouts and logos to satisfy even the most demanding clients. Enhance your marketing campaigns and ensure a perfect success by choosing from our diverse range of designs.",
      },
      {
        icon: "search.png",
        title: "Make a great first impression",
        description:
          "Customize your QR code's URL to be short, memorable, and stand out from competitors. Additionally, use your domain to build brand loyalty and make an excellent first impression.",
      },
      {
        icon: "analytics.png",
        title: "Accurate statistics",
        description:
          "Our detailed tracking and statistics allow you to collect information about your QR code's users, both passively and actively. This information provides valuable insights to help optimize your marketing campaigns.",
      },
      {
        icon: "idea.png",
        title: "Smart customization",
        description:
          "Our platform offers the ability to lock your QR code at any time, and our Smart Redirect feature is tailored to your device. Additionally, we integrate with third-party services to offer you an all-in-one QR code customization experience.",
      },
    ],
  },
  {
    locale: "fr",
    data: [
      {
        icon: "collaborative.png",
        title: "Pas de soucis, pas de confusion",
        description:
          "L'intégration des codes QR lors de la planification initiale et l'ajout de contenu seulement lorsque vous êtes prêt à être en direct, même après l'impression, procure une tranquillité d'esprit et évite les confusions. Vous pouvez modifier vos codes à tout moment et n'importe où pour assurer une messagerie précise et une expérience utilisateur fluide.",
      },
      {
        icon: "portfolio.png",
        title: "Haute qualité d'image et variété",
        description:
          "Nos codes QR maintiennent toujours une haute résolution, quel que soit l'endroit où ils sont imprimés. Vous pouvez les télécharger dans différents formats, y compris JPG, PNG, SVG ou EPS, pour vous assurer qu'ils ont un aspect fantastique sur n'importe quel support.",
      },
      {
        icon: "illustration.png",
        title: "Conceptions disponibles",
        description:
          "Nous proposons une vaste sélection de mises en page et de logos époustouflants pour satisfaire même les clients les plus exigeants. Améliorez vos campagnes marketing et assurez un succès parfait en choisissant parmi notre gamme diversifiée de designs.",
      },
      {
        icon: "search.png",
        title: "Faites une excellente première impression",
        description:
          "Personnalisez l'URL de votre code QR pour qu'elle soit courte, mémorable et se démarque des concurrents. En outre, utilisez votre domaine pour construire la fidélité de la marque et faire une excellente première impression.",
      },
      {
        icon: "analytics.png",
        title: "Statistiques précises",
        description:
          "Notre suivi et nos statistiques détaillés vous permettent de collecter des informations sur les utilisateurs de votre code QR, à la fois de manière passive et active. Ces informations fournissent des informations précieuses pour optimiser vos campagnes marketing.",
      },
      {
        icon: "idea.png",
        title: "Personnalisation intelligente",
        description:
          "Notre plateforme offre la possibilité de verrouiller votre code QR à tout moment, et notre fonctionnalité Smart Redirect est adaptée à votre appareil. En outre, nous nous intégrons à des services tiers pour vous offrir une expérience de personnalisation de code QR tout-en-un.",
      },
    ],
  },
  {
    locale: "es",
    data: [
      {
        icon: "collaborative.png",
        title: "Sin preocupaciones, sin confusión",
        description:
          "La integración de códigos QR durante la planificación inicial y la adición de contenido solo cuando esté listo para estar en vivo, incluso después de la impresión, proporciona tranquilidad y evita confusiones. Puede editar sus códigos en cualquier momento y en cualquier lugar para garantizar una mensajería precisa y una experiencia de usuario perfecta.",
      },
      {
        icon: "portfolio.png",
        title: "Alta calidad de imagen y variedad",
        description:
          "Nuestros códigos QR siempre mantienen una alta resolución, independientemente del lugar donde se impriman. Puede descargarlos en varios formatos, incluidos JPG, PNG, SVG o EPS, para garantizar que se vean excelentes en cualquier medio.",
      },
      {
        icon: "illustration.png",
        title: "Diseños disponibles",
        description:
          "Ofrecemos una amplia selección de diseños y logotipos impresionantes para satisfacer incluso a los clientes más exigentes. Mejore sus campañas de marketing y asegure un éxito perfecto eligiendo entre nuestra amplia gama de diseños.",
      },
      {
        icon: "search.png",
        title: "Causa una gran primera impresión",
        description:
          "Personalice la URL de su código QR para que sea corta, memorable y se destaque entre la competencia. Además, use su dominio para construir la lealtad de la marca y causar una excelente primera impresión.",
      },
      {
        icon: "analytics.png",
        title: "Estadísticas precisas",
        description:
          "Nuestro seguimiento y estadísticas detallados le permiten recopilar información sobre los usuarios de su código QR, tanto de manera pasiva como activa. Esta información proporciona información valiosa para optimizar sus campañas de marketing.",
      },
      {
        icon: "idea.png",
        title: "Personalización inteligente",
        description:
          "Nuestra plataforma ofrece la capacidad de bloquear su código QR en cualquier momento, y nuestra función Smart Redirect está adaptada a su dispositivo. Además, nos integramos con servicios de terceros para ofrecerle una experiencia de personalización de código QR todo en uno.",
      },
    ],
  },
  {
    locale: "pt",
    data: [
      {
        icon: "collaborative.png",
        title: "Sem preocupações, sem confusão",
        description:
          "A integração de códigos QR durante o planejamento inicial e a adição de conteúdo apenas quando estiver pronto para entrar ao vivo, mesmo depois da impressão, proporciona tranquilidade e evita confusões. Você pode editar seus códigos a qualquer momento e em qualquer lugar para garantir uma mensagem precisa e uma experiência perfeita para o usuário.",
      },
      {
        icon: "portfolio.png",
        title: "Alta qualidade de imagem e variedade",
        description:
          "Nossos códigos QR sempre mantêm alta resolução, independentemente do local em que são impressos. Você pode baixá-los em vários formatos, incluindo JPG, PNG, SVG ou EPS, para garantir que eles fiquem ótimos em qualquer meio.",
      },
      {
        icon: "illustration.png",
        title: "Designs disponíveis",
        description:
          "Oferecemos uma ampla seleção de designs e logotipos impressionantes para atender até os clientes mais exigentes. Melhore suas campanhas de marketing e garanta um sucesso perfeito escolhendo entre nossa ampla gama de designs.",
      },
      {
        icon: "search.png",
        title: "Cause uma excelente primeira impressão",
        description:
          "Personalize a URL do seu código QR para que ela seja curta, memorável e se destaque entre a concorrência. Além disso, use seu domínio para construirlealdade da marca e causar uma excelente primeira impressão.",
      },
      {
        icon: "analytics.png",
        title: "Estatísticas precisas",
        description:
          "Nosso rastreamento e estatísticas detalhados permitem que você colete informações sobre os usuários do seu código QR, tanto passiva quanto ativamente. Essas informações fornecem insights valiosos para otimizar suas campanhas de marketing.",
      },
      {
        icon: "idea.png",
        title: "Personalização inteligente",
        description:
          "Nossa plataforma oferece a capacidade de bloquear seu código QR a qualquer momento e nossa função Smart Redirect é adaptada ao seu dispositivo. Além disso, integramos com serviços de terceiros para oferecer uma experiência de personalização de código QR tudo-em-um.",
      },
    ],
  },
  {
    locale: "nl",
    data: [
      {
        icon: "collaborative.png",
        title: "Geen zorgen, geen verwarring",
        description:
          "Het integreren van QR-codes tijdens de initiële planning en het toevoegen van inhoud alleen wanneer deze klaar is om live te gaan, zelfs na het printen, biedt gemoedsrust en voorkomt verwarring. U kunt uw codes op elk moment en overal bewerken om nauwkeurige berichtgeving en een naadloze gebruikerservaring te garanderen.",
      },
      {
        icon: "portfolio.png",
        title: "Hoge beeldkwaliteit en variëteit",
        description:
          "Onze QR-codes behouden altijd een hoge resolutie, ongeacht waar ze worden afgedrukt. U kunt ze downloaden in verschillende formaten, waaronder JPG, PNG, SVG of EPS, om ervoor te zorgen dat ze er geweldig uitzien op elk medium.",
      },
      {
        icon: "illustration.png",
        title: "Beschikbare ontwerpen",
        description:
          "We bieden een uitgebreide selectie van prachtige lay-outs en logo's om zelfs de meest veeleisende klanten tevreden te stellen. Verbeter uw marketingcampagnes en zorg voor een perfect succes door te kiezen uit ons diverse scala aan ontwerpen.",
      },
      {
        icon: "search.png",
        title: "Maak een geweldige eerste indruk",
        description:
          "Pas de URL van uw QR-code aan om kort, memorabel te zijn en op te vallen tussen de concurrentie. Gebruik bovendien uw domein om merkloyaliteit op te bouwen en een uitstekende eerste indruk te maken.",
      },
      {
        icon: "analytics.png",
        title: "Nauwkeurige statistieken",
        description:
          "Onze gedetailleerde tracking en statistieken stellen u in staat informatie te verzamelen over de gebruikers van uw QR-code, zowel passief als actief. Deze informatie biedt waardevolle inzichten om uw marketingcampagnes te optimaliseren.",
      },
      {
        icon: "idea.png",
        title: "Slimme aanpassing",
        description:
          "Ons platform biedt de mogelijkheid om uw QR-code op elk moment te vergrendelen en onze Smart Redirect-functie is op maat gemaakt voor uw apparaat. Bovendien integreren we met diensten van derden om u een alles-in-één QR-code aanpassingservaring te bieden.",
      },
    ],
  },
  {
    locale: "ja",
    data: [
      {
        icon: "collaborative.png",
        title: "心配なし、混乱なし",
        description:
          "初期計画中にQRコードを統合し、印刷後でもコンテンツを追加することで、安心感を提供し、混乱を避けることができます。いつでもどこでもコードを編集して、正確なメッセージングとシームレスなユーザーエクスペリエンスを確保しましょう。",
      },
      {
        icon: "portfolio.png",
        title: "高品質で多様な画像",
        description:
          "当社のQRコードは、印刷される場所に関係なく常に高解像度を維持します。JPG、PNG、SVG、EPSなど、さまざまな形式でダウンロードして、どの媒体でも素晴らしい外観を確保できます。",
      },
      {
        icon: "illustration.png",
        title: "デザインの選択肢",
        description:
          "当社では、最も要求の厳しいクライアントにも満足いただける、見事なレイアウトやロゴの広範な選択肢を提供しています。多様なデザインから選んで、マーケティングキャンペーンを強化し、完璧な成功を確保しましょう。",
      },
      {
        icon: "search.png",
        title: "素晴らしい第一印象を与える",
        description:
          "独自のQRコードのURLを短く、覚えやすく、競合他社から目立つようにカスタマイズしましょう。さらに、ドメインを利用してブランドロイヤルティを構築し、素晴らしい第一印象を与えましょう。",
      },
      {
        icon: "analytics.png",
        title: "正確な統計情報",
        description:
          "当社の詳細なトラッキングと統計情報により、コードのユーザーに関する情報を収集することができます。これらの情報は、マーケティングキャンペーンを最適化するための貴重な洞察を提供します。",
      },
      {
        icon: "idea.png",
        title: "スマートなカスタマイズ",
        description:
          "当社のプラットフォームでは、いつでもQRコードをロックできる機能があり、Smart Redirect機能がデバイスに合わせて調整されています。さらに、サードパーティサービスと統合して、オールインワンのQRコードカスタマイズ体験を提供しています。",
      },
    ],
  },
  {
    locale: "vi",
    data: [
      {
        icon: "collaborative.png",
        title: "Không lo, không nhầm lẫn",
        description:
          "Tích hợp mã QR trong kế hoạch ban đầu và chỉ thêm nội dung khi sẵn sàng đi vào hoạt động, ngay cả sau khi in, mang lại sự yên tâm và tránh nhầm lẫn. Bạn có thể chỉnh sửa mã của mình bất cứ lúc nào và ở bất cứ đâu để đảm bảo thông điệp chính xác và trải nghiệm người dùng mượt mà.",
      },
      {
        icon: "portfolio.png",
        title: "Chất lượng hình ảnh cao và đa dạng",
        description:
          "Mã QR của chúng tôi luôn duy trì độ phân giải cao, bất kể nơi chúng được in. Bạn có thể tải xuống chúng dưới định dạng JPG, PNG, SVG hoặc EPS để đảm bảo chúng trông tuyệt vời trên bất kỳ phương tiện nào.",
      },
      {
        icon: "illustration.png",
        title: "Các mẫu thiết kế đa dạng",
        description:
          "Chúng tôi cung cấp một lựa chọn rộng các bố cục và logo đẹp mắt để đáp ứng nhu cầu của các khách hàng khó tính nhất. Tăng cường chiến dịch tiếp thị của bạn và đảm bảo thành công hoàn hảo bằng cách chọn từ các mẫu thiết kế đa dạng của chúng tôi.",
      },
      {
        icon: "search.png",
        title: "Tạo ấn tượng đầu tiên tuyệt vời",
        description:
          "Tùy chỉnh địa chỉ URL mã QR của bạn để nó ngắn, dễ nhớ và nổi bật so với đối thủ cạnh tranh. Ngoài ra, sử dụng tên miền của bạn để xây dựng lòng trung thành của thương hiệu và tạo ấn tượng đầu tiên tuyệt vời.",
      },
      {
        icon: "analytics.png",
        title: "Thống kê chính xác",
        description:
          "Thông tin theo dõi và thống kê chi tiết của chúng tôi cho phép bạn thu thập thông tin về người dùng mã QR của mình, cả một cách chủ động và không chủ động. Thông tin này cung cấp những hiểu biết quý giá để tối ưu hóa chiến dịch tiếp thị của bạn.",
      },
      {
        icon: "idea.png",
        title: "Tùy chỉnh thông minh",
        description:
          "Nền tảng của chúng tôi cung cấp khả năng khóa mã QR của bạn bất cứ lúc nào và tính năng Chuyển hướng Thông minh được điều chỉnh cho phù hợp với thiết bị của bạn. Ngoài ra chúng tôi tích hợp với các dịch vụ của bên thứ ba để cung cấp trải nghiệm tùy chỉnh mã QR tất cả trong một.",
      },
    ],
  },
  {
    locale: "it",
    data: [
      {
        icon: "collaborative.png",
        title: "Nessun problema, nessuna confusione",
        description:
          "Integrando i codici QR durante la pianificazione iniziale e aggiungendo il contenuto solo quando si è pronti per andare in diretta, anche dopo la stampa, si ottiene la tranquillità e si evita la confusione. È possibile modificare i propri codici in qualsiasi momento e ovunque per garantire un messaggio preciso e un'esperienza utente senza soluzione di continuità.",
      },
      {
        icon: "portfolio.png",
        title: "Alta qualità dell'immagine e varietà",
        description:
          "I nostri codici QR mantengono sempre l'alta risoluzione, indipendentemente dal luogo in cui sono stampati. È possibile scaricarli in vari formati, tra cui JPG, PNG, SVG o EPS, per garantire che siano belli su qualsiasi mezzo.",
      },
      {
        icon: "illustration.png",
        title: "Design disponibili",
        description:
          "Offriamo una vasta selezione di splendidi layout e loghi per soddisfare anche i clienti più esigenti. Migliora le tue campagne di marketing e assicurati un successo perfetto scegliendo dalla nostra gamma diversificata di design.",
      },
      {
        icon: "search.png",
        title: "Fai una grande prima impressione",
        description:
          "Personalizza l'URL del tuo codice QR per renderlo breve, memorabile e distinguerti dalla concorrenza. Inoltre, utilizza il tuo dominio per costruire la fedeltà al marchio e fare un'ottima prima impressione.",
      },
      {
        icon: "analytics.png",
        title: "Statistiche accurate",
        description:
          "Il nostro dettagliato tracciamento e le statistiche ti consentono di raccogliere informazioni sugli utenti del tuo codice QR, sia in modo passivo che attivo. Queste informazioni forniscono preziose informazioni per aiutare ad ottimizzare le tue campagne di marketing.",
      },
      {
        icon: "idea.png",
        title: "Personalizzazione intelligente",
        description:
          "La nostra piattaforma offre la possibilità di bloccare il proprio codice QR in qualsiasi momento, e la nostra funzione di reindirizzamento intelligente è su misura per il tuo dispositivo. Inoltre, ci integriamo con servizi di terze parti per offrirti un'esperienza di personalizzazione del codice QR all-in-one.",
      },
    ],
  },
  {
    locale: "de",
    data: [
      {
        icon: "collaborative.png",
        title: "Keine Sorgen, keine Verwirrung",
        description:
          "Die Integration von QR-Codes während der Planungsphase und das Hinzufügen von Inhalten erst, wenn diese bereit sind, live zu gehen, auch nach dem Druck, sorgt für Gelassenheit und vermeidet Verwirrung. Sie können Ihre Codes jederzeit und überall bearbeiten, um eine genaue Nachrichtenübermittlung und nahtlose Benutzererfahrung zu gewährleisten.",
      },
      {
        icon: "portfolio.png",
        title: "Hohe Bildqualität und Vielfalt",
        description:
          "Unsere QR-Codes behalten immer eine hohe Auflösung bei, unabhängig davon, wo sie gedruckt werden. Sie können sie in verschiedenen Formaten wie JPG, PNG, SVG oder EPS herunterladen, um sicherzustellen, dass sie auf jedem Medium großartig aussehen.",
      },
      {
        icon: "illustration.png",
        title: "Verfügbare Designs",
        description:
          "Wir bieten eine große Auswahl an beeindruckenden Layouts und Logos, um selbst die anspruchsvollsten Kunden zufriedenzustellen. Verbessern Sie Ihre Marketingkampagnen und sichern Sie sich einen perfekten Erfolg, indem Sie aus unserer vielfältigen Designs auswählen.",
      },
      {
        icon: "search.png",
        title: "Machen Sie einen großartigen ersten Eindruck",
        description:
          "Passen Sie die URL Ihres QR-Codes an, um sie kurz, leicht merkbar und von Mitbewerbern abzuheben. Verwenden Sie außerdem Ihre Domain, um Markentreue aufzubauen und einen hervorragenden ersten Eindruck zu hinterlassen.",
      },
      {
        icon: "analytics.png",
        title: "Genaue Statistiken",
        description:
          "Unsere detaillierten Tracking- und Statistikfunktionen ermöglichen es Ihnen, Informationen über die Nutzer Ihrer QR-Codes passiv und aktiv zu sammeln. Diese Informationen bieten wertvolle Einblicke, um Ihre Marketingkampagnen zu optimieren.",
      },
      {
        icon: "idea.png",
        title: "Intelligente Anpassung",
        description:
          "Unsere Plattform bietet die Möglichkeit, Ihren QR-Code jederzeit zu sperren, und unsere Smart Redirect-Funktion ist auf Ihr Gerät zugeschnitten. Außerdem integrieren wir uns mit Drittanbieterdiensten, um Ihnen ein All-in-One-Erlebnis bei der Anpassung von QR-Codes zu bieten.",
      },
    ],
  },
  {
    locale: "zh",
    data: [
      {
        icon: "collaborative.png",
        title: "无忧无惑",
        description:
          "在初始规划阶段集成二维码，并在准备好上线后添加内容，即使在打印之后，也可以提供放心和避免混淆的效果。您可以随时随地编辑您的二维码，以确保准确的信息传达和无缝的用户体验。",
      },
      {
        icon: "portfolio.png",
        title: "高品质多样化",
        description:
          "我们的二维码始终保持高分辨率，无论它们在哪里打印。您可以下载它们的各种格式，包括JPG、PNG、SVG或EPS，以确保它们在任何媒介上都看起来很棒。",
      },
      {
        icon: "illustration.png",
        title: "设计可供选择",
        description:
          "我们提供各种惊人的布局和标志，以满足最苛刻的客户。通过选择我们多样化的设计，增强您的营销活动，确保完美的成功。",
      },
      {
        icon: "search.png",
        title: "留下良好的第一印象",
        description:
          "定制您的二维码URL，使其简短、易记，并从竞争对手中脱颖而出。此外，使用您的域名来建立品牌忠诚度，留下良好的第一印象。",
      },
      {
        icon: "analytics.png",
        title: "准确的统计数据",
        description:
          "我们详细的跟踪和统计数据允许您收集关于您的二维码用户的信息，无论是被动的还是积极的。这些信息提供了有价值的见解，以帮助优化您的营销活动。",
      },
      {
        icon: "idea.png",
        title: "智能定制",
        description:
          "我们的平台提供随时锁定您的二维码的功能，我们的智能重定向功能也可根据您的设备进行定制。此外，我们与第三方服务集成，为您提供全方位的二维码定制体验。",
      },
    ],
  },
];
